<template>
  <VPopup
    class="create-deliverer-popup"
    position="bottom"
    align="right"
    show-pointer
    closable
    :visible="true"
    :target="target"
    @close="$core.dialogs.DelivererCreatePopup.hide()"
  >
    <div class="deliverer-create-form">
      <VForm ref="form">
        <VInput
          ref="nameInput"
          v-model="form.name"
          label="Название транспортной компании"
          layout="vertical"
          required
          :max-length="255"
        />

        <VSelect
          ref="countryInput"
          v-model="form.country"
          label="Страна"
          layout="vertical"
          placeholder="Введите название страны"
          data-url="countries.getList"
          option-identity="code"
          option-label="name"
          :minimum-input-length="1"
          required
        />

        <VSelect
          ref="mainTimeZoneInput"
          v-model="form.mainTimeZone"
          label="Часовой пояс"
          layout="vertical"
          placeholder="Введите название города"
          option-label="stringRepresentation"
          :options="timeZoneOptions"
          required
        />
      </VForm>

      <VButton theme="primary" @click="create">Создать</VButton>
      <div class="helper-text">Ctrl + Enter для сохранения</div>
    </div>
  </VPopup>
</template>

<style lang="scss" src="./DelivererCreatePopup.scss"/>

<script lang="ts">

import Partner          from '@/domains/Partners/Partner';
import PartnersService  from '@/domains/Partners/PartnersService';
import TimeZone         from '@/domains/TimeZones/TimeZone';
import TimeZonesService from '@/domains/TimeZones/TimeZonesService';

export default defineComponent({
  name: 'DelivererCreatePopup',

  emits: ['close'],

  props: {
    target: {
      type:    HTMLElement,
      default: null,
    },
    onCreate: {
      type:    Function as PropType<(deliverer: Partner) => void>,
      default: null,
    },
  },

  data() {
    return {
      form:            new Partner(),
      timeZoneOptions: [] as TimeZone[],
    };
  },

  async mounted() {
    window.addEventListener('keydown', this.keydownHandler);

    await this.initTimezoneList();

    this.focusNameInput();
  },

  beforeUnmount() {
    window.removeEventListener('keydown', this.keydownHandler);
  },

  methods: {
    async initTimezoneList(): Promise<void> {
      this.timeZoneOptions = await TimeZonesService.getList();
    },

    focusNameInput(): void {
      const nameInput = this.$refs.nameInput as { $el: HTMLElement } | undefined;

      if (nameInput) {
        const element = nameInput.$el.querySelector('input');

        if (element) {
          element.focus();
        }
      }
    },

    keydownHandler(event: KeyboardEvent): void {
      if (event.isTrusted && event.code === 'Enter' && event.ctrlKey) {
        this.create();
      }
    },

    /**
     * Своя валидация: VForm попапа изолирован от VForm карточки ЗТК,
     * поля создания перевозчика не участвуют в её сабмите.
     */
    async create(): Promise<void> {
      const form = this.$refs.form as any;

      await form.validate();

      if (form.isValid === true) {
        this.form.type = 'deliverer';

        const success = await PartnersService.add(this.form as Partner);

        if (success) {
          if (this.onCreate) {
            this.onCreate(this.form);
          }

          this.$core.dialogs.DelivererCreatePopup.resolve();
        }
      }
    },
  },
});
</script>
